import ptPT_Imagery from '@assets/translations/pt-PT.json';
//ANTD LOCALES
import deDE from 'antd/lib/locale/de_DE';
import enGB from 'antd/lib/locale/en_GB';
import enUS from 'antd/lib/locale/en_US';
import esES from 'antd/lib/locale/es_ES';
import frFR from 'antd/lib/locale/fr_FR';
import huHU from 'antd/lib/locale/hu_HU';
import itIT from 'antd/lib/locale/it_IT';
import ptBR from 'antd/lib/locale/pt_BR';
import ptPT from 'antd/lib/locale/pt_PT';
import trTR from 'antd/lib/locale/tr_TR';
import i18n from 'i18next';
import deDE_Imagery from '../../assets/translations/de.json';
import enGB_imagery from '../../assets/translations/en-GB.json';
import enUS_Imagery from '../../assets/translations/en.json';
import esAR_Imagery from '../../assets/translations/es-AR.json';
import es_Imagery from '../../assets/translations/es.json';
import frFR_Imagery from '../../assets/translations/fr.json';
import huHU_Imagery from '../../assets/translations/hu.json';
import itIT_Imagery from '../../assets/translations/it-IT.json';
import ptBR_Imagery from '../../assets/translations/pt-BR.json';
import trTR_Imagery from '../../assets/translations/tr.json';

import numeral from 'numeral';

// dayjs translations
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/hu';
import 'dayjs/locale/it';
import 'dayjs/locale/pt';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/tr';

// numeral locales
import 'numeral/locales';
import { initReactI18next } from 'react-i18next';

export const availableLanguages = {
  'en-US': 'en',
  'pt-BR': 'pt-BR',
  'pt-PT': 'pt-PT',
  'es-AR': 'es-AR',
  'en-GB': 'en-GB',
  'es-ES': 'es',
  'it-IT': 'it',
  'de-DE': 'de',
  'hu-HU': 'hu',
  'tr-TR': 'tr',
  'fr-FR': 'fr',
};

export const resources = {
  'en-US': { translation: enUS_Imagery },
  'en-GB': { translation: enGB_imagery },
  'pt-BR': { translation: ptBR_Imagery },
  'pt-PT': { translation: ptPT_Imagery },
  'es-AR': { translation: esAR_Imagery },
  'es-ES': { translation: es_Imagery },
  'it-IT': { translation: itIT_Imagery },
  'de-DE': { translation: deDE_Imagery },
  'tr-TR': { translation: trTR_Imagery },
  'hu-HU': { translation: huHU_Imagery },
  'fr-FR': { translation: frFR_Imagery },
};

export const getLanguageTag = (language: string, fallback: boolean = true) => {
  const languageOptions = {
    en: 'en-US',
    en_us: 'en-US',
    en_US: 'en-US',
    'en-US': 'en-US',
    'en-GB': 'en-GB',
    pt: 'pt-BR',
    pt_br: 'pt-BR',
    pt_BR: 'pt-BR',
    'pt-BR': 'pt-BR',
    pt_pt: 'pt-PT',
    pt_PT: 'pt-PT',
    'pt-PT': 'pt-PT',
    'es-AR': 'es-AR',
    es_ar: 'es-AR',
    es_AR: 'es-AR',
    ['es-419']: 'es-AR',
    es: 'es-ES',
    es_es: 'es-ES',
    es_ES: 'es-ES',
    'es-ES': 'es-ES',
    it: 'it-IT',
    it_is: 'it-IT',
    it_IT: 'it-IT',
    'it-IT': 'it-IT',
    de: 'de-DE',
    de_de: 'de-DE',
    de_DE: 'de-DE',
    'de-DE': 'de-DE',
    tr: 'tr-TR',
    tr_tr: 'tr-TR',
    tr_TR: 'tr-TR',
    'tr-TR': 'tr-TR',
    fr: 'fr-FR',
    fr_fr: 'fr-FR',
    fr_FR: 'fr-FR',
    'fr-FR': 'fr-FR',
    hu: 'hu-HU',
    hu_hu: 'hu-HU',
    hu_HU: 'hu-HU',
    'hu-HU': 'hu-HU',
  };

  return languageOptions[language] || (fallback ? 'en-US' : language);
};

i18n.use(initReactI18next).init({
  fallbackLng: 'en-US',
  resources,
  interpolation: {
    escapeValue: false,
  },
  compatibilityJSON: 'v4',
});

export const getLanguageKey = () => {
  switch (i18n.language) {
    case 'en-US':
      return 'header.account.languages.en_us';
    case 'en-GB':
      return 'header.account.languages.en_gb';
    case 'pt-BR':
      return 'header.account.languages.pt_br';
    case 'pt-PT':
      return 'header.account.languages.pt_pt';
    case 'es-AR':
      return 'header.account.languages.es_ar';
    case 'es-ES':
      return 'header.account.languages.es';
    case 'it-IT':
      return 'header.account.languages.it';
    case 'de-DE':
      return 'header.account.languages.de';
    case 'tr-TR':
      return 'header.account.languages.tr';
    case 'fr-FR':
      return 'header.account.languages.fr';
    case 'hu-HU':
      return 'header.account.languages.hu';
    default:
      return 'header.account.languages.en_us';
  }
};

export const getLocaleDateTimeKey = (lng: string) => {
  switch (lng) {
    case 'en-US':
      return 'en';
    case 'en-GB':
      return 'en-gb';
    case 'pt-BR':
      return 'pt-br';
    case 'pt-PT':
      return 'pt';
    case 'es-AR':
    case 'es-ES':
      return 'es';
    case 'it-IT':
      return 'it';
    case 'de-DE':
      return 'de';
    case 'tr-TR':
      return 'tr';
    case 'fr-FR':
      return 'fr';
    case 'hu-HU':
      return 'hu';
    default:
      return 'en';
  }
};

export const getLocaleAntd = (value = localStorage.getItem('language')) => {
  switch (value) {
    case 'en-US':
      return enUS;
    case 'en-GB':
      return enGB;
    case 'pt-BR':
      return ptBR;
    case 'pt-PT':
      return ptPT;
    case 'es-AR':
    case 'es-ES':
      return esES;
    case 'it-IT':
      return itIT;
    case 'de-DE':
      return deDE;
    case 'tr-TR':
      return trTR;
    case 'fr-FR':
      return frFR;
    case 'hu-HU':
      return huHU;
    default:
      return enUS;
  }
};

/**
 * numeral ships short locale keys (`it`, `de`, `fr`, `tr`, `hu`) — not the full BCP-47 tags
 * the language selector uses. Passing a tag straight through produced keys like `it-it`,
 * which numeral has no bundle for.
 *
 * `numeral.locale()` does not validate: it stores whatever key it is given and the failure
 * only surfaces later, inside `.format()`, as
 * `TypeError: Cannot read properties of undefined (reading 'delimiters')`. That crashed the
 * Farm Highlights drawer mid-render for every Italian, German, French, Turkish and Hungarian
 * user (CAD-3191), along with Yield Analysis, Prescriptions and the Data Layer legends.
 */
const NUMERAL_LOCALES: Readonly<Record<string, string>> = {
  en: 'en-gb',
  'en-us': 'en-gb',
  'en-gb': 'en-gb',
  pt: 'pt-br',
  'pt-br': 'pt-br',
  'pt-pt': 'pt-pt',
  es: 'es',
  'es-ar': 'es',
  'es-es': 'es-es',
  it: 'it',
  'it-it': 'it',
  de: 'de',
  'de-de': 'de',
  tr: 'tr',
  'tr-tr': 'tr',
  fr: 'fr',
  'fr-fr': 'fr',
  hu: 'hu',
  'hu-hu': 'hu',
};

const NUMERAL_FALLBACK_LOCALE = 'en-gb';

export const setNumeralLocale = (languageKey: string) => {
  const locale = NUMERAL_LOCALES[languageKey.toLowerCase()] ?? NUMERAL_FALLBACK_LOCALE;

  // Belt and braces: an unregistered key would be accepted here and only blow up later,
  // mid-render, in whichever component formats a number first.
  numeral.locale(numeral.locales[locale] ? locale : NUMERAL_FALLBACK_LOCALE);
};

export default i18n;
